// 推送任务
export default {
  BASE_URL: '',
  api: [
    {
      name: 'pushRecord',
      desc: '推送操作',
      method: 'POST',
      path: '/fm/task/pushRecord'
    },
    {
      name: 'taskList',
      desc: '推送任务列表',
      method: 'GET',
      path: '/fm/task/list'
    },
    {
      name: 'logList',
      desc: '推送日志列表',
      method: 'GET',
      path: '/fm/task/log/list'
    },
    {
      name: 'getPushTypeIdLabel',
      desc: '推送类型下拉',
      method: 'GET',
      path: '/fm/task/getPushTypeIdLabel'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/push/pushRecord.js